<template>
  <v-container fluid class="salestarget-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn @click="runTargetDialog" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Target
              </v-btn>

            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Targeting... Please wait"
              class="salestargets-table"
              show-select
              single-select
              item-key="_id"
              sort-desc
              sort-by="salestargetnum"
              :footer-props="footer"
              :headers="headers"
              :items="salestargets"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Sales Target?
                    </v-card-title>
                    <v-card-text>
                      {{ deletesalestarget.salestargetnum }} 
                      {{ deletesalestarget.salestargetname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletesalestarget)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.salestargetimage="{ item }">
                    <v-img
                    v-if="item.salestargetimage" 
                    v-bind:src="item.salestargetimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.driverid="{ item }">
                <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.driverid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.driverid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.driverid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.driverid!=null && users.length>0 ? users.find(user=>user._id == item.driverid)['username'] : '' }} </span></p>
              </template>
              <template v-slot:item.loaderid="{ item }">
                <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.loaderid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.loaderid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.loaderid!=null && users.length>0 ? users.find(user=>user._id == item.loaderid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.loaderid!=null && users.length>0 ? users.find(user=>user._id == item.loaderid)['username'] : '' }} </span></p>
              </template>
              <template v-slot:item.salestargetnum="{ item }">
                <p class="two-line">{{ item.salestargettype  }}</p>
                <p class="two-line">{{ item.salestargetnum  }}</p>
                <p class="two-line">{{ new Date(item.salestargetdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ item.locationid!=null && locations.find(location=>location._id == item.locationid)!=null ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
                <p class="two-line">{{ item.vehicleid!=null && vehicles.find(vehicle=>vehicle._id == item.vehicleid)!=null ? vehicles.find(vehicle=>vehicle._id == item.vehicleid)['vehiclename'] : '' }}</p>
              </template>
              <template v-slot:item.orderquantity="{ item }">
                {{ item.orderquantity.toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.orderweight="{ item }">
                {{ item.orderweight.toFixed(1) }}
              </template>
              <template v-slot:item.salestargetstatus="{ item }">
                <v-chip
                  small
                  :color="item.salestargetstatus=='New' ? 'primaryConst white--text' :  
                  item.salestargetstatus=='Targeted' ? 'warning white--text' : 
                  item.salestargetstatus=='Unloaded' ? 'greyTint white--text' : 
                  'secondaryConst white--text'">
                  {{ item.salestargetstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isRunTargeting"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Create Sales Targets</span>
          </v-card-title>
            <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-menu
                          ref="menu_salestargetdate"
                          v-model="menu_salestargetdate"
                          :close-on-content-click="false"
                          :return-value.sync="newloading.salestargetdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="newloading.salestargetdate"
                              label="Targeting Date"
                              v-bind="attrs"
                              v-bind:value="newloading.salestargetdate"
                              v-on="on"
                              single-line hint="Please choose the loading date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="newloading.salestargetdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_salestargetdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_salestargetdate.save(newloading.salestargetdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isRunTargeting = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="runTarget"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
        </v-dialog>
    </div>
  </v-container>
</template>

<script>
import config from "../../../config";
import { mapState, mapActions } from 'vuex';
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'SalesTargetList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      isRunTargeting: false,
      menu_salestargetdate: false,
      deletesalestarget: {},
      newloading: {},
      headers: [
        { text: 'Image', value: 'salestargetimage', width: '5%', sortable: false },
        { text: 'Order', value: 'salestargetnum', width: '10%' },
        { text: 'Location-Vehicle', value: 'locationid' },
        { text: 'Driver', value: 'driverid', width: '12%' },
        { text: 'Targeter', value: 'loaderid', width: '12%' },
        { text: 'Quantity', value: 'orderquantity' },
        { text: 'Weight (Kg)', value: 'orderweight' },
        { text: 'Status', value: 'salestargetstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
    }
  },
  computed: {
    ...mapState('SalesTarget', ['salestargets', 'isReceiving', 'isDeleting', 'idToDelete', 'salestargetsMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
    ...mapState('Vehicle', ['vehicles']),
  },
  async created () {
    await this.getSalesTargetsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vehicles.length==0) await this.getVehiclesRequest();
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('SalesTarget', ["getSalesTargetsRequest","deleteSalesTargetRequest","runTargetRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('Vehicle', ["getVehiclesRequest"]),
    editItem(item) {
      this.$router.push({ name: 'SalesTargetEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'SalesTargetPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'SalesTargetView', params: item })
    },
    deleteItem(item) {
      this.deleteSalesTargetRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletesalestarget = {
        _id: item._id,
        salestargetnum: item.salestargetnum,
        salestargetname: item.salestargetname,
      }
    },
    runTargetDialog() {
      let date = formatStdDate(new Date());
      this.newloading = {salestargetdate: date};
      this.isRunTargeting = true;
    },
    async runTarget(){
      console.log(this.newloading)
      await this.runTargetRequest(this.newloading)
      await this.getSalesTargetsRequest();
      this.isRunTargeting = false;
    }
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
